import { render, staticRenderFns } from "./CourseForm.vue?vue&type=template&id=736a98b4&scoped=true"
import script from "./CourseForm.vue?vue&type=script&lang=js"
export * from "./CourseForm.vue?vue&type=script&lang=js"
import style0 from "./CourseForm.vue?vue&type=style&index=0&id=736a98b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736a98b4",
  null
  
)

export default component.exports